const NoItems = (
    {
        title = "No Products Found!",
        subText = "",
        imageHeight = '20vh',
        imageWidth = '20vh',
        shadow = true
    }
) => {
    return (
        <div className="h-75 w-100 d-flex justify-content-center align-items-center">
            <div className={`col-8 text-center small px-2 py-5 ${shadow ? 'shadow' : ''} rounded my-5`}>
                <img alt="logo" style={{ objectFit: "contain", height: imageHeight, width: imageWidth }} src="/assets/images/logo.png" />
                <h3>{title}</h3>
                <p>{subText}</p>
            </div>
        </div>
    );
}

export default NoItems;